import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {rootStoreModule, RootStoreGetters, RootStoreActions} from './root/root-store.module';
import VuexPersistence, {AsyncStorage} from 'vuex-persist';
import {idb} from './persistent-store';
import {Route} from 'vue-router';
import {Dictionary} from 'vue-router/types/router';
import {APP_MODULE} from './state';

Vue.use(Vuex);
/* eslint-disable */
/* tslint:disable */
const storeProto = Vuex.Store.prototype;
// @ts-ignore
storeProto.registerModuleOnce = function(path, rawModule, force = false) {
  // @ts-ignore
  if (this.hasModule(path)) {
    if (!force) {
      return false;
    }
    this.unregisterModule(path);
  }
  return this.registerModule(path, rawModule, {preserveState: force ? false : this.state[path]});
};

// Path can be an array or a string: ['my', 'nested', 'module'] or 'my/nested/module'
// @ts-ignore
storeProto.hasModule = function(path) {
  let pathArray = path instanceof Array ? path : path.split('/');
  // @ts-ignore
  let m = this._modules.root;
  // @ts-ignore
  return pathArray.every((p) => {
    m = m._children[p];
    return m;
  });
};

const vuexIdb = new VuexPersistence({
  asyncStorage: true,
  storage: idb as AsyncStorage,
  reducer: (state: any) => {
    return {
      route: undefined,
      [APP_MODULE]: state[APP_MODULE]
        ? {
            ...state[APP_MODULE],
            accommodationFilters: [],
            dineFilters: [],
            exploreFilters: [],
            recommendations: [],
            regionFilters: [],
            tripSuggestions: [],
            myTrips: [],
            themeTrips: [],
            availableSolutionFilters: [],
            alternatives: [],
            recommendationDetails: {},
            tripsWithPois: [],
            destOptions: {},
            recommendationsBlackList: null,
            additionalPOIs: [],
            // selectedSolutionFilters: [],
          }
        : undefined,
    };
  },
  saveState: (key, state, storage: any) => {
    storage!.setItem(key, state);
  },
});

export const store = new Vuex.Store<any>({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    rootStoreModule,
  },
  // plugins: [vuexIdb.plugin as any],
});
/* eslint-enable */
/* tslint:enable */
export interface IRouterState {
  route: Route;
}

export function useStore<T>(): Store<T> {
  return store;
}
// export function getSessionId(): string {
//   return store.state.sessionId || '';
// }
export function getProblemSessionId(): string {
  return store.getters[RootStoreGetters.problemSessionId];
}
export function updateSessionId(value: string) {
  return store.dispatch(RootStoreActions.updateSessionId, value);
}

export function getRouteStep(): string {
  return store.state.route.params.step;
}

export function getRouterParams(): Dictionary<string> {
  return store.state.route.params;
}
export function getCurrentRoute(): Route {
  return store.state.route;
}
